import type { MisconceptionDefinition } from '../types'

/** SPR — Latijnse & Griekse leenwoorden + C-klank-leenwoorden (slice 2). */
export const latijnGrieksCMisconceptions: MisconceptionDefinition[] = [
  {
    id: 'spr.latin-plural-english-s',
    label: 'Engels meervoud i.p.v. Latijns',
    module: 'SpellingRegel',
    description:
      'Leerling gebruikt het Engelse meervoud met -s in plaats van het Latijnse meervoud (bijv. "museums" i.p.v. "musea").',
    typicalFamilies: ['SPR-LEEN-LATIJN'],
  },
  {
    id: 'spr.latin-plural-dutch-en',
    label: 'Nederlands meervoud i.p.v. Latijns',
    module: 'SpellingRegel',
    description:
      'Leerling gebruikt het Nederlandse meervoud met -en in plaats van het Latijnse meervoud (bijv. "museumen" i.p.v. "musea").',
    typicalFamilies: ['SPR-LEEN-LATIJN'],
  },
  {
    id: 'spr.latin-plural-apostrophe',
    label: 'Apostrof-meervoud bij Latijns woord',
    module: 'SpellingRegel',
    description:
      'Leerling gebruikt een apostrof voor het meervoud van een Latijns woord (bijv. "museum\'s" i.p.v. "musea").',
    typicalFamilies: ['SPR-LEEN-LATIJN'],
  },
  {
    id: 'spr.latin-plural-correct-rejected',
    label: 'Correct Latijns meervoud afgewezen',
    module: 'SpellingRegel',
    description:
      'Leerling herkent een correct Latijns meervoud (musea, podia, centra) niet en wijst het ten onrechte af.',
    typicalFamilies: ['SPR-LEEN-LATIJN'],
  },
  {
    id: 'spr.latin-plural-exception-missed',
    label: 'Latijnse uitzondering niet herkend',
    module: 'SpellingRegel',
    description:
      'Leerling herkent niet dat een woord (zoals album → albums) een uitzondering is op de Latijnse -um → -a regel.',
    typicalFamilies: ['SPR-LEEN-LATIJN'],
  },
  {
    id: 'spr.latin-plural-singular-as-plural',
    label: 'Enkelvoud gebruikt als meervoud',
    module: 'SpellingRegel',
    description:
      'Leerling gebruikt het enkelvoud (museum, centrum) waar het meervoud (musea, centra) hoort.',
    typicalFamilies: ['SPR-LEEN-LATIJN'],
  },
  {
    id: 'spr.latin-plural-rule-misapplied',
    label: 'Latijnse regel verkeerd toegepast',
    module: 'SpellingRegel',
    description:
      'Leerling past de verkeerde Latijnse meervoudsregel toe (bijv. -us-regel op een -um-woord).',
    typicalFamilies: ['SPR-LEEN-LATIJN'],
  },
  {
    id: 'spr.greek-origin-confused',
    label: 'Griekse herkomst verward',
    module: 'SpellingRegel',
    description:
      'Leerling verwart Griekse leenwoorden met Franse of Engelse leenwoorden, of herkent Griekse woorddelen niet.',
    typicalFamilies: ['SPR-LEEN-GRIEKS'],
  },
  {
    id: 'spr.greek-spelling-english',
    label: 'Engelse spelling bij Grieks woord',
    module: 'SpellingRegel',
    description:
      'Leerling gebruikt de Engelse spellingvariant van een Grieks woord in het Nederlands (bijv. "filosofy" i.p.v. "filosofie", of behoudt "ph" i.p.v. "f").',
    typicalFamilies: ['SPR-LEEN-GRIEKS'],
  },
  {
    id: 'spr.greek-origin-french',
    label: 'Frans woord aangezien voor Grieks',
    module: 'SpellingRegel',
    description:
      'Leerling herkent een Frans leenwoord (op -ant/-ent/-eau) ten onrechte als Grieks.',
    typicalFamilies: ['SPR-LEEN-GRIEKS'],
  },
  {
    id: 'spr.greek-origin-english',
    label: 'Engels woord aangezien voor Grieks',
    module: 'SpellingRegel',
    description:
      'Leerling herkent een Engels leenwoord (op -er, -ing) ten onrechte als Grieks.',
    typicalFamilies: ['SPR-LEEN-GRIEKS'],
  },
  {
    id: 'spr.greek-spelling-y-kept',
    label: 'Engelse -y uitgang behouden bij Grieks woord',
    module: 'SpellingRegel',
    description:
      'Leerling behoudt de Engelse uitgang -y bij een Grieks leenwoord in plaats van -ie (filosofy i.p.v. filosofie).',
    typicalFamilies: ['SPR-LEEN-GRIEKS'],
  },
  {
    id: 'spr.greek-spelling-double-consonant',
    label: 'Dubbele medeklinker bij Grieks woord',
    module: 'SpellingRegel',
    description:
      'Leerling verdubbelt een medeklinker in een Grieks leenwoord ten onrechte (fillosofie i.p.v. filosofie).',
    typicalFamilies: ['SPR-LEEN-GRIEKS'],
  },
  {
    id: 'spr.greek-spelling-fy-instead-fi',
    label: 'Fy- in plaats van fi- bij Grieks woord',
    module: 'SpellingRegel',
    description:
      'Leerling schrijft fy- in plaats van fi- in een Grieks leenwoord (fylosofie i.p.v. filosofie).',
    typicalFamilies: ['SPR-LEEN-GRIEKS'],
  },
  {
    id: 'spr.c-klank-k-als-s',
    label: 'K-klank als S-klank gezien',
    module: 'SpellingRegel',
    description:
      'Leerling denkt dat C vóór a, o of u als S klinkt (terwijl het K is).',
    typicalFamilies: ['SPR-LEEN-C-S-K'],
  },
  {
    id: 'spr.c-klank-s-als-k',
    label: 'S-klank als K-klank gezien',
    module: 'SpellingRegel',
    description:
      'Leerling denkt dat C vóór e of i als K klinkt (terwijl het S is).',
    typicalFamilies: ['SPR-LEEN-C-S-K'],
  },
  {
    id: 'spr.c-altijd-k',
    label: 'Denkt C altijd K',
    module: 'SpellingRegel',
    description: 'Leerling denkt dat de letter C altijd als K klinkt.',
    typicalFamilies: ['SPR-LEEN-C-S-K'],
  },
  {
    id: 'spr.c-altijd-s',
    label: 'Denkt C altijd S',
    module: 'SpellingRegel',
    description: 'Leerling denkt dat de letter C altijd als S klinkt.',
    typicalFamilies: ['SPR-LEEN-C-S-K'],
  },
  {
    id: 'spr.c-niet-leenwoord',
    label: 'C-woord niet als leenwoord herkend',
    module: 'SpellingRegel',
    description:
      'Leerling herkent niet dat woorden met C leenwoorden zijn die hun originele spelling behouden.',
    typicalFamilies: ['SPR-LEEN-C-S-K'],
  },
  {
    id: 'spr.c-klank-onhoorbaar',
    label: 'Denkt C onhoorbaar',
    module: 'SpellingRegel',
    description:
      'Leerling denkt dat de C in bepaalde woorden niet hoorbaar is.',
    typicalFamilies: ['SPR-LEEN-C-S-K'],
  },
]
